import { MainState } from './state';

export const getters = {
  hasAdminAccess: (state: MainState) => {
    return state.userProfile && state.userProfile.is_superuser && state.userProfile.is_active;
  },
  loginError: (state: MainState) => state.logInError,
  dashboardShowDrawer: (state: MainState) => state.dashboardShowDrawer,
  dashboardMiniDrawer: (state: MainState) => state.dashboardMiniDrawer,
  userProfile: (state: MainState) => state.userProfile,
  token: (state: MainState) => state.token,
  isLoggedIn: (state: MainState) => state.isLoggedIn,
  firstNotification: (state: MainState) => state.notifications.length > 0 && state.notifications[0],
  showProgress: (state: MainState) => state.showProgress,
  lang: (state: MainState) => state.lang,
  version: (state: MainState) => state.version,
  config: (state: MainState) => state.config,
};
